
import { Component, Prop, Vue } from 'vue-property-decorator'
import RedCooperationUtils from '@/utilsTenant/RedCooperationUtils'
import { TextImageTeaser, CustomButton, Card } from 'ui-library'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import i18n from '@/i18n'
import axios from 'axios'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { isDev } from '@/utils/utils'

dayjs.extend(customParseFormat)

@Component({
  i18n,
  components: {
    TextImageTeaser,
    CustomButton,
    Card
  }
})
export default class TeaserWelcome extends Vue {
  private assetsBaseUrl: string = window.ENV_CONFIG.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''

  private partnerProxyId: string | null = null

  private resizeTimeout: ReturnType<typeof setTimeout> | null = null

  @Prop({ default: false, type: Boolean })
  private showModificationDate!: boolean

  @Prop({ required: true, type: Boolean })
  private isPlacedInHeader!: boolean

  public jsonFileName = 'teaser1'
  public loading = true
  public showJsonTeaser: boolean | null = null

  public jsonTeaserRemote: null | {
    tag: string
    imageUrl: string
    imageBackground: string
    buttonUrl: string
    buttonText: string
    target: string // '_self' | '_parent' | '_blank' | '_top'
    ctaSecondary: boolean
    headerText: string
    teaserContent: string
    footerText: string
    contentBackground: string
    redCooperationPartner: boolean
    hide: boolean
  } = null

  get isRedCooperationPartner(): boolean {
    return RedCooperationUtils.isRedCooperationPartner() ?? true
  }

  public created(): void {
    this.partnerProxyId = getPartnerProxyId()
  }

  public async mounted(): Promise<void> {
    this.$nextTick(async function () {
      try {
        const origin = isDev() ? 'http://localhost:9999' : window.location.origin ?? 'https://da-direkt.de'
        const response = await axios.get(`${origin}/dacp/${this.jsonFileName}.json`, {})
        this.jsonTeaserRemote = response.data
        this.showJsonTeaser = true
        this.loading = false
      } catch {
        this.showJsonTeaser = false
        this.loading = false
        console.error('Error in Request: Did not receive a valid json for teaser')
      } finally {
        if (this.jsonTeaserRemote?.hide) {
          this.showJsonTeaser = false
        }
        // jsonTeaserRemote.redCooperationPartner: if true then hide teaser when partner is a red cooperation partner
        if (this.isRedCooperationPartner && this.jsonTeaserRemote?.redCooperationPartner) {
          this.showJsonTeaser = false
        }
      }
    })
  }

  get showTeaser(): boolean {
    if (this.isPlacedInHeader) {
      return screen.width >= 600
    } else {
      return screen.width < 600
    }
  }

  public redirect(url: string): void {
    if (!this.jsonTeaserRemote) return
    const target = this.jsonTeaserRemote.target
    if (!url || url === '') {
      throw new Error('Url path is not available!')
    }
    if (target !== '_self' && target !== '_parent' && target !== '_blank' && target !== '_top') {
      window.open(url, '_blank')
    } else if (target === '_self' || target === '_parent' || target === '_blank' || target === '_top') {
      window.open(url, this.jsonTeaserRemote.target)
    }
  }
}
